import { Filter, X } from "lucide-react"
import React, { ReactNode } from "react"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function FilterDropdown({ children, onReset, count }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-9 flex items-center focus-visible:ring-0">
          <Filter className="mr-2 h-4 w-4" />
          Filters
          {count && count > 0 ? (
            <span className="ml-1 rounded-full bg-primary w-5 h-5 text-[10px] flex items-center justify-center text-primary-foreground">
              {count}
            </span>
          ) : null}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[300px]">
        <div className="flex items-center justify-between p-2">
          <DropdownMenuLabel>Filter Options</DropdownMenuLabel>
          {onReset && (
            <Button variant="ghost" size="sm" onClick={onReset} className="h-8 px-2 text-xs border dark:border-gray-800">
              <X className="mr-1 h-3 w-3" />
              Reset
            </Button>
          )}
        </div>
        <DropdownMenuSeparator />
        <div className="p-4 flex flex-col gap-3">{children}</div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
